import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import {
  ICreateFranchise,
  IParamsGetFranchise,
  IPayloadDeleteFranchise,
  IReponseFranchiseDetail,
  IResponseGetFranchise,
} from '~/utils/interface/franchise';

const franchiseApi = {
  createFranchise(data: ICreateFranchise) {
    return axiosClient.post<IApiBaseResponse<null>>(`api/admin/franchise`, data);
  },

  getFranchise(params: IParamsGetFranchise) {
    const url = `api/admin/franchise`;
    return axiosClient.get<IApiBaseResponse<IResponseGetFranchise>>(url, { params });
  },
  getFranchiseDetail(id: string) {
    return axiosClient.get<IApiBaseResponse<IReponseFranchiseDetail>>(`api/admin/franchise/${id}`);
  },

  updateFranchise(id: string | undefined, data: ICreateFranchise) {
    return axiosClient.put<IApiBaseResponse<null>>(`api/admin/franchise/${id}`, data);
  },

  deleteFranchise(data: IPayloadDeleteFranchise) {
    const url = `api/admin/franchise`;
    return axiosClient.delete<IApiBaseResponse<null>>(url, { data });
  },
};

export default franchiseApi;
